import { Workspace } from "../../adapters/workspace";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, nextLogo }) =>
    present(
      repository
        .savePlanzoneLogo(planzone, nextLogo)
        .then((nextLogo) => ({ planzone, nextLogo }))
        .catch(() => Promise.reject({ nextLogo, planzone })),
    );
}

export type { Interactor };

export { createInteractor };
